import { render, staticRenderFns } from "./BarDefault.vue?vue&type=template&id=65964e7d&scoped=true&"
import script from "./BarDefault.vue?vue&type=script&lang=js&"
export * from "./BarDefault.vue?vue&type=script&lang=js&"
import style0 from "./BarDefault.vue?vue&type=style&index=0&id=65964e7d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65964e7d",
  null
  
)

export default component.exports